import { store } from '@bangjelkoski/store2';
export default class LocalStorage {
    storage;
    constructor(namespace) {
        this.storage = store.namespace(namespace);
    }
    get(key, defaultValue = {}) {
        return this.storage.get(key) || defaultValue;
    }
    has(key) {
        return this.storage.has(key);
    }
    set(key, value) {
        this.storage.set(key, value);
    }
    remove(key) {
        this.storage.remove(key);
    }
    clear() {
        this.storage.clear();
    }
}
